var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79688 19V5H12.3219C13.4052 5 14.4052 5.33333 15.3219 6C16.2385 6.66667 16.6969 7.59167 16.6969 8.775C16.6969 9.625 16.5052 10.2792 16.1219 10.7375C15.7385 11.1958 15.3802 11.525 15.0469 11.725C15.4635 11.9083 15.926 12.25 16.4344 12.75C16.9427 13.25 17.1969 14 17.1969 15C17.1969 16.4833 16.6552 17.5208 15.5719 18.1125C14.4885 18.7042 13.4719 19 12.5219 19H6.79688ZM9.82188 16.2H12.4219C13.2219 16.2 13.7094 15.9958 13.8844 15.5875C14.0594 15.1792 14.1469 14.8833 14.1469 14.7C14.1469 14.5167 14.0594 14.2208 13.8844 13.8125C13.7094 13.4042 13.1969 13.2 12.3469 13.2H9.82188V16.2ZM9.82188 10.5H12.1469C12.6969 10.5 13.0969 10.3583 13.3469 10.075C13.5969 9.79167 13.7219 9.475 13.7219 9.125C13.7219 8.725 13.5802 8.4 13.2969 8.15C13.0135 7.9 12.6469 7.775 12.1969 7.775H9.82188V10.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.2bfee4109a79d400e3bfa9636650d71a.svg";
export { ForwardRef as ReactComponent };